import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const ARBOROFOH_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/arborofoh/logo.png",
        alt: "Arbor Counseling Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 26,
  state: "OH",
  departmentIds: [99, 115, 121],
};
